<template>
  <div class="app-transport-section">
    <div
      v-if="!isEdit"
      class="app-transport-section__bg"
      :class="bgClass"
      :style="gradient"
    >
      <span class="app-transport-section__text">{{ text }}</span>
    </div>
    <app-svg-icon
      class="app-transport-section__section-icon"
      :class="iconClass"
      :name="isValid ? 'Calibration_Section' : 'Calibration_Section_Red'"
    ></app-svg-icon>
    <template v-if="isEdit">
      <div
        contenteditable
        v-if="isTitle"
        class="app-transport-section__bg"
        @focus="titleFocus"
      >
        <span class="app-transport-section__text">
          {{ innerValue | price() }} л.
        </span>
      </div>
      <vue-numeric
        v-show="!isTitle"
        :min="0"
        v-model="innerValue"
        :precision="0"
        separator="space"
        outputType="Number"
        decimalSeparator=","
        emptyValue=""
        @focus="handleFocus"
        @blur="handleBlur"
        class="app-transport-section__input-volume"
        ref="inputLiters"
      ></vue-numeric>
    </template>
  </div>
</template>

<script>
import AppSvgIcon from '@/components/common/AppSvgIcon.vue';

export default {
  name: 'AppTransportSection',
  components: {
    AppSvgIcon,
  },
  props: {
    /**
     * Фокус в поле ввоа объема во врема создания компонента
     */
    isFocus: {
      type: Boolean,
      default: false,
    },
    /**
     * Значение инпута
     */
    value: {
      type: [String, Number],
      default: '',
    },
    /**
     * Текст внутри секции
     */
    text: {
      type: String,
      default: 'нет секций',
    },
    /**
     * Дефолтное значение если секций нет
     */
    isEmpty: {
      type: Boolean,
      default: true,
    },
    /**
     * Добавляет красный фон
     */
    isRedBG: {
      type: Boolean,
      default: false,
    },
    /**
     * Объем, который нужно загрузить в секцию
     */
    volume: {
      type: Number,
      default: 0,
    },
    /**
     * Размер секции
     */
    maxVolume: {
      type: Number,
      default: 0,
    },
    /**
     * Если нужно редактировать поле
     */
    isEdit: {
      type: Boolean,
    },
    /**
     * Если нужен клик по секции
     */
    isClick: {
      type: Boolean,
    },
    /**
     * Если секия валидна (для красного цвета)
     */
    isValid: {
      type: Boolean,
      default: true,
    },
  },
  data: (vm) => ({
    innerValue: vm.value,
    isTitle: true,
  }),
  computed: {
    /**
     * Классы для фона
     */
    bgClass() {
      return [
        {
          'app-transport-section__bg--empty': this.isEmpty,
          'app-transport-section__bg--error': this.isRedBG,
        },
      ];
    },
    /**
     * Классы для иконки
     */
    iconClass() {
      return [
        {
          'app-transport-section__section-icon--pointer': this.isClick,
        },
      ];
    },
    /**
     * Процент белого цвета
     */
    percentWhite() {
      if (this.maxVolume === 0) {
        return 100;
      }
      // eslint-disable-next-line no-mixed-operators
      return 100 - (this.volume / this.maxVolume) * 100;
    },
    /**
     * Градиент, показывает кол-во занятого пространства в процентах
     */
    gradient() {
      return this.isEmpty || this.isRedBG
        ? {}
        : {
            background: ` linear-gradient(180deg, #fff ${this.percentWhite}%, #FFED47 0%)`,
          };
    },
  },
  watch: {
    innerValue(value) {
      this.$emit('input', value);
    },
  },
  created() {
    if (this.isFocus) {
      setTimeout(() => {
        this.titleFocus();
      }, 500);
    }
  },
  methods: {
    /**
     * Заголовок в фокусе
     */
    titleFocus() {
      this.isTitle = false;
      this.$nextTick(() => {
        this.$refs.inputLiters.$el.focus();
      });
    },
    /**
     * Действие на событие input
     * @param event
     */
    handleInput(event) {
      this.innerValue = event.target.value;
      this.$emit('input', event.target.value);
    },
    /**
     * Событие focus
     */
    handleFocus() {
      this.$emit('focus');
    },
    /**
     * Событие blur
     */
    handleBlur() {
      this.$emit('blur');
      this.isTitle = true;
    },
  },
};
</script>

<style lang="scss">
.app-transport-section {
  $root: &;

  position: relative;
  width: 88px;
  height: 70px;

  &__input-volume {
    position: absolute;
    top: 11px;
    left: 0;
    z-index: 1;
    display: flex;
    width: 83px;
    height: 36px;
    padding-right: 15px;
    padding-left: 3px;
    font-size: rem(12);
    font-weight: 300;
    text-align: center !important;
    background: transparent;
    border: 0;
    border-radius: 0 30px 30px 0;
  }

  &__section-icon {
    position: absolute;
    top: 0;
    left: 0;
    width: 88px;
    height: 70px;

    &--pointer {
      cursor: pointer;
    }
  }

  &__text {
    margin: auto;
    font-size: rem(12);
    font-weight: 300;
    color: $gray-dark;
  }

  &__bg {
    position: absolute;
    top: 11px;
    left: 0;
    display: flex;
    width: 83px;
    height: 36px;
    border-radius: 0 30px 30px 0;
  }

  &__bg--empty {
    background-color: $color-gray-1;
  }

  &__bg--error {
    background-color: $color-red;

    #{$root}__text {
      color: $white;
    }
  }
}
</style>
